import { z } from 'zod';

/** SavedView.resource value for `BillsPageSimple`. */
export const AP_BILLS_SIMPLE_SAVED_VIEW_RESOURCE = 'ap/bills/simple' as const;

const BILLS_SIMPLE_TAB_VALUES = [
  'overview',
  'drafts',
  'for-approval',
  'approved',
  'for-payment',
  'automatic-debit',
  // Legacy `history` tab is accepted for backward compatibility with persisted saved views;
  // it is migrated to `approved` on read in the web app (see `tabFromSavedState`).
  'history',
  'accepted-waiting',
] as const;

export const billsSimpleSavedViewTabSchema = z.enum(BILLS_SIMPLE_TAB_VALUES);

export type BillsSimpleSavedViewTab = z.infer<typeof billsSimpleSavedViewTabSchema>;

const tablePrefsSchema = z
  .object({
    visibility: z.record(z.string(), z.boolean()).optional(),
    columnOrder: z.array(z.string()).optional(),
  })
  .optional();

/**
 * Versioned JSON stored in `SavedView.state` for the AP bills simple list.
 * `filters` is a loose JSON object merged with tab defaults on apply (see web `bills-saved-view-state`).
 */
export const billsSimpleSavedViewStateV1Schema = z.object({
  v: z.literal(1),
  activeTab: billsSimpleSavedViewTabSchema,
  filters: z.record(z.string(), z.unknown()),
  vendorName: z.string().optional(),
  tablePrefs: tablePrefsSchema,
});

export type BillsSimpleSavedViewStateV1 = z.infer<typeof billsSimpleSavedViewStateV1Schema>;

export function parseBillsSimpleSavedViewState(raw: unknown): BillsSimpleSavedViewStateV1 | null {
  const parsed = billsSimpleSavedViewStateV1Schema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
